const colorClasses = {
  gray: 'bg-white/10 hover:bg-white/15 text-slate-300 border border-white/20',
  blue: 'bg-sky-500/20 hover:bg-sky-500/30 text-sky-400 border border-sky-500/30',
  red: 'bg-rose-500/20 hover:bg-rose-500/30 text-rose-400 border border-rose-500/30',
  lime: 'bg-emerald-500/20 hover:bg-emerald-500/30 text-emerald-400 border border-emerald-500/30',
};

const ButtonItem = ({ text, color, onClick, className }) => {
  return (
    <button
      className={`${className || ''} px-4 py-2 rounded-xl text-sm font-semibold transition-colors cursor-pointer ${
        colorClasses[color] || colorClasses.gray
      }`}
      onClick={onClick}
      type="button">
      {text}
    </button>
  );
};

export default ButtonItem;
